export default __webpack_public_path__ + "static/pict1-1f5eb560672a7b3259875a910a6c2f8c.png";